import { render } from "./CustomiseResults.vue?vue&type=template&id=4fb681a8"
import script from "./CustomiseResults.vue?vue&type=script&lang=js"
export * from "./CustomiseResults.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/library.milim.com/src/public/library/themes/stirtingale/resources/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__